import React, { useState, useEffect, useRef, useContext } from "react";
import Breadcrumbs from "./Breadcrumb";
import "datatables.net-bs4/js/dataTables.bootstrap4";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import { Modal } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { DataGrid } from "@material-ui/data-grid";
import { notify, notifyWarning } from "../Toastmessage/Toastmessage";
import { ToastContainer } from "react-toastify";
import TablePagination from "@material-ui/core/TablePagination";
import moment from "moment";
import AuthContext from "../../../context/auth-context";
import { SubjectService } from "../../../services/subject-service";
import { useHistory } from "react-router-dom";


export const Content = (props) => {
  const ctx = useContext(AuthContext);

  const authPermission = localStorage.getItem("PermissionDetails");

  const [createHide, setCreateEdit] = useState(true);
  const [editHide, setHideEdit] = useState(true);
  const [deleteHide, setHideDelete] = useState(true);

  useEffect(() => {
    JSON.parse(authPermission).forEach(function (loca) {
      if (
        loca.access_module.module_name == "SUBJECT" &&
        loca.permission_edit === true
      ) {
        setHideEdit(false);
      }
      if (
        loca.access_module.module_name == "SUBJECT" &&
        loca.permission_delete === true
      ) {
        setHideDelete(false);
      }

      if (
        loca.access_module.module_name == "SUBJECT" &&
        loca.permission_add === true
      ) {
        setCreateEdit(false);
      }
    });
  }, [authPermission]);

  const format2 = "YYYY-MM-DD";

  const [page, setPage] = React.useState(0);

  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [count, setDataCount] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const formRef = useRef();

  const [submitloading, setSubmitLoading] = useState(true);

  const [state, setState] = useState(false);

  const [subjectID, setSubjectID] = useState();

  const history = useHistory();

  const handleShow4 = (e) => {
    setState({ show4: true });
    setSubjectID(e);
  };

  const handleShow3 = (e) => {
    setState({ show3: true });
  };

  const handleClose = (e) => {
    setState({ show3: false });
  };

  const [subject, setSubject] = useState([]);

  const subjectSearch = async () => {
    try {
      const result = await SubjectService.subjectDetailsSearch(rowsPerPage, page);
      setSubject(result.results);
      setDataCount(result.pagination.total);
    } catch (err) {
      if (err.response?.data?.message) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something went wrong");
      }
    }
  };

  useEffect(() => {
    subjectSearch()
  }, [rowsPerPage, page, count]);

  const onSubmitForm = async (
    values,

    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    
      setSubmitLoading(false);
  
      try {
        await SubjectService.subjectCreate(values);

        setSubmitLoading(true);
        notify("Subject successfully added");
        formRef.current.resetForm();
        handleClose();
        subjectSearch();
      } catch (err) {
        setSubmitLoading(true);
        //show error toast
        if (err.response.data.message !== undefined) {
          notifyWarning(err.response.data.message);
          notifyWarning(err.response.data.message[0]);
        } else {
          notifyWarning("Something Wrong");
        }
      }
  };

  const onDelete = async () => {
    //todo extra validations
    setSubmitLoading(false);
    try {
      await SubjectService.subjectDelete(subjectID);

      setSubmitLoading(true);
      notify("Subject successfully deleted");
      subjectSearch();
      handleClose();
    } catch (err) {
      setSubmitLoading(true);
      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }

      //show error toast
    }
  };

  const calculateHeight = () => {
    // Approximate row height + header + footer
    return rowsPerPage * 52 + 150;
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 2,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "name",
      headerName: "Name",
      flex: 5,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
    },
    {
      field: "created_at",
      headerName: "Created Date",
      sortable: false,
      flex: 3,
      disableClickEventBubbling: true,
      cellClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return <div>{moment(params.row.created_at).format(format2)}</div>;
      },
    },
    {
      field: "status",
      headerName: "Status",
      sortable: false,
      flex: 3,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        if (params.row.status === "ACTIVE") {
          return (
            <div>
              <span className="badge badge-success">ACTIVE</span>
            </div>
          );
        } else {
          return (
            <div>
              <span className="badge badge-primary">DEACTIVE</span>
            </div>
          );
        }
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div
            onClick={() => {
              history.push(`/edit-subject/${params.row.id}`);
            }}
            style={{ cursor: "pointer" }}
            hidden={editHide}
          >
            <i className="fas fa-pencil-alt text-secondary" />
          </div>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      sortable: false,
      flex: 1,
      disableClickEventBubbling: true,
      headerClassName: ctx.darkMode ? "active_dark" : "deactive_dark",
      renderCell: (params) => {
        return (
          <div hidden={deleteHide}>
            <i
              className="far fa-trash-alt ms-text-danger"
              onClick={() => {
                handleShow4(params.row.id);
              }}
              style={{ cursor: "pointer" }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div className="ms-content-wrapper">
      <div>
        <ToastContainer />
      </div>
      <div className="row">
        <div className="col-md-12">
          <Breadcrumbs />
          <div className="ms-panel">
            <div className="ms-panel-header">
              <div className="row">
                <div className="col-md-10">
                  <h6>Subject </h6>
                </div>
                <div>
                  <Modal
                    show={state.show4}
                    onHide={handleClose}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                  >
                    <Modal.Header>
                      <h3 className="modal-title has-icon ms-icon-round ">
                        Confirm Deletion
                      </h3>
                      <button
                        type="button"
                        className="close"
                        onClick={handleClose}
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </Modal.Header>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "2vh",
                      }}
                    >
                      <h6 style={{ color: "red" }}>
                        Are you sure you want to remove this item ?
                      </h6>
                    </div>
                    <Modal.Footer>
                      <div className="col-md-2" hidden={submitloading}>
                        <div className="spinner spinner-7">
                          <div className="bounce1" />
                          <div className="bounce2" />
                          <div className="bounce3" />
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn btn-primary shadow-none"
                        style={{ backgroundColor: "red" }}
                        onClick={onDelete}
                      >
                        Delete
                      </button>

                      <button
                        type="button"
                        className="btn btn-light"
                        onClick={handleClose}
                      >
                        Cancel
                      </button>
                    </Modal.Footer>
                  </Modal>
                </div>
                <div className="col-md-2">
                  {" "}
                  <div className="col-md-2 col-sm-4">
                    <button
                      type="button"
                      className="btn btn-primary shadow-none"
                      onClick={handleShow3}
                      hidden={createHide}
                    >
                      Add New
                    </button>
                  </div>
                  <Modal
                    show={state.show3}
                    onHide={handleClose}
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                  >
                    <Modal.Header>
                      <h3 className="modal-title has-icon ms-icon-round ">
                        <i className="flaticon-share bg-primary text-white" />{" "}
                        New Subject
                      </h3>
                      <button
                        type="button"
                        className="close"
                        onClick={handleClose}
                      >
                        <span aria-hidden="true">×</span>
                      </button>
                    </Modal.Header>
                    <Formik
                      initialValues={{
                        name: "",
                      }}
                      validationSchema={Yup.object().shape({
                        name: Yup.string().required("Required"),
                        
                      })}
                      onSubmit={onSubmitForm}
                      innerRef={formRef}
                    >
                      {({
                        errors,
                        handleBlur,
                        handleChange,
                        touched,
                        values,
                        submitForm,
                        isValid,
                        setFieldValue,
                      }) => (
                        <div>
                          <Modal.Body>
                            <div>
                              <div className="mb-3">
                                <label htmlFor="validationCustom08">Name</label>
                                <div className="input-group">
                                  <input
                                    name="name"
                                    type="text"
                                    className="form-control"
                                    id="nameid"
                                    placeholder="Name"
                                    required
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.name}
                                  />
                                </div>
                                <div style={{ color: "red", fontSize: "12px" }}>
                                  {touched.name && errors.name}
                                </div>
                              </div>
                            </div>
                            <div className="col-md-2" hidden={submitloading}>
                              <div className="spinner spinner-7">
                                <div className="bounce1" />
                                <div className="bounce2" />
                                <div className="bounce3" />
                              </div>
                            </div>
                          </Modal.Body>
                          <Modal.Footer>
                            <button
                              type="button"
                              className="btn btn-light"
                              onClick={handleClose}
                            >
                              Cancel
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary shadow-none"
                              onClick={submitForm}
                            >
                              Add
                            </button>
                          </Modal.Footer>
                        </div>
                      )}
                    </Formik>
                  </Modal>{" "}
                </div>
              </div>
            </div>
            <div className="ms-panel-body">
              <div className="table-responsive">
                <div style={{ minHeight: calculateHeight(), height: calculateHeight(), flex: "100%" }}>
                  <DataGrid
                    rows={subject}
                    columns={columns}
                    disableExtendRowFullWidth={false}
                    pageSize={rowsPerPage}
                    pagination
                    hideFooter
                    autoHeight
                  />
                  <TablePagination
                    component="div"
                    count={count}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
